import * as types from '../actionTypes'

const initialState = {
  searching: false,
  searchTerm: '',
  data: null,
  messages: null
}

export default function reducer(state = initialState, action) {
  switch (action.type) {

    case types.TODO_SEARCH_REQUEST: {
      return {
        ...state,
        searching: true,
        data: (action.payload === state.searchTerm) ? state.data : null,
        messages: null
      }
    }

    case types.TODO_CLEAR_DATA: {
      return {
        ...state,
        data: null,
        messages: null
      }
    }

    case types.SET_SEARCH_TERM: {
      return {
        ...state,
        searchTerm: action.payload
      }
    }

    case types.TODO_SEARCH_RESULTS: {
      const data = action.payload.data || {}
      const searchTermToSet = action.payload.searchTerm || state.searchTerm
      return {
        ...state,
        searchTerm: searchTermToSet,
        data: data.cntrData,
        messages: data.messages,
        searching: false
      }
    }

    default:
      return state
  }
}
